// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1mw1q","imageUploader":"EGiftCard_imageUploader__3B6kP"};